import { FiltroConsultaHistorico, RespuestaTSAT } from "../modelo/ReporteHistoricoModelo";

export const CONSULTAR_HISTORICO_REPUESTA = "CONSULTAR_HISTORICO_REPUESTA";
export const DESCARGAR_XLS_HISTORICO = "DESCARGAR_XLS_HISTORICO";
export const HISTORICO_RESPUESTA_CONSULTADOS = "HISTORICO_RESPUESTA_CONSULTADOS";
export const ERROR_CONSULTANDO_HISTORICO_RESPUESTA = "ERROR_CONSULTANDO_HISTORICO_RESPUESTA";
export const EXITO_DESCARGAR_RESPUESTAS_XLS = "EXITO_DESCARGAR_RESPUESTAS_XLS";
export const ERROR_DESCARGAR_RESPUESTAS_XLS = "ERROR_DESCARGAR_RESPUESTAS_XLS";

export const consultarHistoricoRespuesta = (filtro: FiltroConsultaHistorico) => ({ type: CONSULTAR_HISTORICO_REPUESTA, filtro});
export const descargarXLSHistorico = (filtro: FiltroConsultaHistorico) => ({ type: DESCARGAR_XLS_HISTORICO, filtro});
export const historicoRespuestaConsultados = (datosRespuesta: Array<RespuestaTSAT>, paginas: number, totalDatos: number) => ({ 
    type: HISTORICO_RESPUESTA_CONSULTADOS, datosRespuesta, paginas, totalDatos });
export const errorConsultandoHistoricoRespuesta = () => ({ type: ERROR_CONSULTANDO_HISTORICO_RESPUESTA });
export const exitoDescargarRespuestasXLS = () => ({ type: EXITO_DESCARGAR_RESPUESTAS_XLS});
export const errorDescargarRespuestasXLS = () => ({ type: ERROR_DESCARGAR_RESPUESTAS_XLS});


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_historico_rta/modulos/historicoRespuestaActions.ts